/* this file added by Bearer Web Developer  */
import { Button, Menu } from '@mui/material';
import React from 'react';
import styles from './itemsMenu.module.scss';
import { useAppState } from '../../../../../states/app-state';
import { observer } from "mobx-react-lite";
import { useThemeMode } from '../../../../../states/contexts/theme';
interface Props {
    parentRef: React.RefObject<HTMLDivElement | null>
}
const ItemsMenu: React.FC<Props> = observer(({ parentRef }) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const appState = useAppState();
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    const { searchItems, setSearchItems } = appState?.ReservedOrders;
    const selectedAll = searchItems?.destination_address && searchItems?.destination_details && searchItems?.client_order_number && searchItems?.recipient_name && searchItems?.recipient_phone_number;
    return (
        <>
            <div className={styles.button_menu_part}>
                <Button className={styles.button_menu} onClick={handleClick}>
                    {
                        theme === 'dark' ? <img src="/filter-search-white.svg" alt="" width={20} height={20} /> :
                            <img src="/filter-search-grey.svg" alt="" width={20} height={20} />
                    }
                </Button>
            </div>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                MenuListProps={{ 'aria-labelledby': 'basic-button' }}
                style={{ top: "5px", borderRadius: "10px" }}
                slotProps={{
                    paper: {
                        style: {
                            padding: "0px",
                            background: theme === "dark" ? "#676767" : "var(--neutral-hsb-92, #EAEAEA)",
                            borderRadius: "5px",
                            boxShadow: "0 7px 8.7px -5px rgba(0, 0, 0, 0.15)",
                            width: `${(parentRef.current as any)?.offsetWidth}px` || '190px',
                        },
                    }

                }}

            >
                <section className={styles.menu_content}  data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
                    <h3>Search from this items:</h3>
                    <div className={styles.items_list}>
                        <label className={styles.all}>
                            <input type="checkbox"
                                checked={selectedAll}
                                onChange={(e) => {
                                    console.log(e.target.checked);
                                    setSearchItems({
                                        destination_address: e.target.checked,
                                        destination_details: e.target.checked,
                                        client_order_number: e.target.checked,
                                        recipient_name: e.target.checked,
                                        recipient_phone_number: e.target.checked,
                                    });
                                }} />
                            <span className={styles.checkmark}>
                                {
                                    theme === 'dark' ?  <img src="/tick-black.svg" alt="" width={5} height={3.92} /> :
                                    <img src="/tick-white.svg" alt="" width={5} height={3.92} />
                                }
                            </span>
                            Select All
                        </label>
                        <line></line>
                        <div className={styles.items_part}>
                            <div className={styles.items}>
                                <label className={styles.item}>
                                    <input type="checkbox"
                                        checked={searchItems?.destination_address || false}
                                        onChange={(e) => {
                                            setSearchItems({
                                                ...searchItems,
                                                destination_address: e.target.checked,
                                            });
                                        }} />
                                    <span className={styles.checkmark}>
                                        <span></span>
                                    </span>
                                    Address
                                </label>
                                <label className={styles.item}>
                                    <input type="checkbox"
                                        checked={searchItems?.destination_details || false}
                                        onChange={(e) => {
                                            setSearchItems({
                                                ...searchItems,
                                                destination_details: e.target.checked,
                                            });
                                        }} />
                                    <span className={styles.checkmark}>
                                        <span></span>
                                    </span>
                                    More Details
                                </label>
                                <label className={styles.item}>
                                    <input type="checkbox"
                                        checked={searchItems?.client_order_number || false}
                                        onChange={(e) => {
                                            setSearchItems({
                                                ...searchItems,
                                                client_order_number: e.target.checked,
                                            });
                                        }} />
                                    <span className={styles.checkmark}>
                                        <span></span>
                                    </span>
                                    Order Number
                                </label>
                                <label className={styles.item}>
                                    <input type="checkbox"
                                        checked={searchItems?.recipient_name || false}
                                        onChange={(e) => {
                                            setSearchItems({
                                                ...searchItems,
                                                recipient_name: e.target.checked,
                                            });
                                        }} />
                                    <span className={styles.checkmark}>
                                        <span></span>
                                    </span>
                                    Customer Name
                                </label>
                                       <label className={styles.item}>
                                    <input type="checkbox"
                                        checked={searchItems?.recipient_phone_number || false}
                                        onChange={(e) => {
                                            setSearchItems({
                                                ...searchItems,
                                                recipient_phone_number: e.target.checked,
                                            });
                                        }} />
                                    <span className={styles.checkmark}>
                                        <span></span>
                                    </span>
                                    Phone
                                </label>
                            </div>
                        </div>

                    </div>
                </section>
            </Menu>
        </>
    )
})
export default ItemsMenu;